import { Injectable } from '@angular/core';
import { eventServicesList } from 'src/app/core/services/event-services-list';
import { BaseEventsService } from 'src/app/core/services/base-event-service';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceDocumentsEventsService extends BaseEventsService {
  constructor() {
    super(eventServicesList.workspaceDocumentsList);
  }
}
